module.exports = __webpack_public_path__ + "static/logo-4955e22c7b8634a3dcf1466a389fafcc.svg";